import * as jsPdf from 'jspdf';
import { ITest } from "src/Interfaces/TestInterface";
import { IWell } from "src/Interfaces/WellInterface";
import * as DATA from './PopDataMud';
import * as MM from './SpecMilsMud';


export const createMudReportPdfPage = (test: ITest, well: IWell, logoBlob: HTMLImageElement, mudReport: jsPdf, draft?: boolean) => {
    borderDraw(mudReport);

    mudReport.setFillColor(MM.HEADER_COLOR);

    // HEADER RECTANGLES
    let tempWidth = MM.ONE_THIRD_WIDTH / 3;
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH, tempWidth, MM.MUD_REPORT_HEADER_HEIGHT, 'F');

    let tempLeft = MM.PAGE_BORDER_WIDTH + MM.TWO_THIRD_WIDTH;
    let tempTop = MM.PAGE_BORDER_WIDTH + MM.MUD_REPORT_HEADER_HEIGHT / 3;
    tempWidth = MM.ONE_THIRD_WIDTH;
    let tempHeight = MM.MUD_REPORT_HEADER_HEIGHT / 6;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempTop += MM.MUD_REPORT_HEADER_HEIGHT / 3;
    tempWidth = MM.ONE_THIRD_WIDTH * 7 / 24;
    tempHeight = MM.MUD_REPORT_HEADER_HEIGHT / 3;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempLeft += MM.ONE_THIRD_WIDTH / 2;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH, MM.FULL_WIDTH, MM.MUD_REPORT_HEADER_HEIGHT, 'S');

    // HEADER LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH, MM.ONE_THIRD_WIDTH, MM.MUD_REPORT_HEADER_HEIGHT, 3, mudReport);
    equalLinesHorizonal(MM.PAGE_BORDER_WIDTH + MM.TWO_THIRD_WIDTH, MM.PAGE_BORDER_WIDTH, MM.ONE_THIRD_WIDTH, MM.MUD_REPORT_HEADER_HEIGHT, 3, mudReport);
    equalLinesVertical(MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH, MM.FULL_WIDTH, MM.MUD_REPORT_HEADER_HEIGHT, 3, mudReport);

    tempLeft = MM.PAGE_BORDER_WIDTH + MM.ONE_THIRD_WIDTH / 3;
    mudReport.line(tempLeft, MM.PAGE_BORDER_WIDTH, tempLeft, MM.MUD_REPORT_HEADER_HEIGHT + MM.PAGE_BORDER_WIDTH);

    tempTop = MM.PAGE_BORDER_WIDTH + MM.MUD_REPORT_HEADER_HEIGHT / 3;
    tempHeight = MM.MUD_REPORT_HEADER_HEIGHT / 3;
    tempLeft = MM.PAGE_BORDER_WIDTH + MM.TWO_THIRD_WIDTH;
    equalGrid(tempLeft, tempTop, MM.ONE_THIRD_WIDTH, tempHeight, 2, 3, mudReport);

    tempLeft += MM.ONE_THIRD_WIDTH / 12;
    tempTop += MM.MUD_REPORT_HEADER_HEIGHT / 3;
    tempWidth = MM.ONE_THIRD_WIDTH * 5 / 12;
    equalGrid(tempLeft, tempTop, tempWidth, tempHeight, 2, 2, mudReport);
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);

    tempLeft = MM.PAGE_BORDER_WIDTH + MM.TWO_THIRD_WIDTH + MM.ONE_THIRD_WIDTH / 2;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);

    tempLeft += MM.ONE_THIRD_WIDTH / 12;
    equalGrid(tempLeft, tempTop, tempWidth, tempHeight, 2, 2, mudReport);
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);

    // WELL INFO RECTANGLES
    borderDraw(mudReport);
    let tempNumRows = MM.WELL_INFO_ROWS;
    tempLeft = MM.PAGE_BORDER_WIDTH;
    tempTop = MM.WELL_INFO_TOP;
    tempWidth = MM.FULL_WIDTH;
    tempHeight = MM.WELL_INFO_HEIGHT / tempNumRows;
    for (let i = 0; i < tempNumRows; i += 2) {
        tempTop = MM.WELL_INFO_TOP + MM.WELL_INFO_HEIGHT * i / tempNumRows;
        mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');
    }
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.WELL_INFO_TOP, MM.FULL_WIDTH, MM.WELL_INFO_HEIGHT, 'S');


    // WELL INFO LINES
    tableDraw(mudReport);
    tempLeft = MM.PAGE_BORDER_WIDTH;
    tempTop = MM.WELL_INFO_TOP;
    tempWidth = MM.FULL_WIDTH;
    tempHeight = MM.WELL_INFO_HEIGHT;
    equalGrid(tempLeft, tempTop, tempWidth, tempHeight, 6, 3, mudReport);

    tempLeft = MM.PAGE_BORDER_WIDTH + MM.TWO_THIRD_WIDTH + MM.ONE_THIRD_WIDTH * 2 / 3;
    tempTop = MM.WELL_INFO_TOP + MM.WELL_INFO_HEIGHT * 1 / 3;
    tempWidth = MM.ONE_THIRD_WIDTH;
    tempHeight = MM.WELL_INFO_HEIGHT * 2 / 3;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);

    // DRILL STRING RECTANGLES
    borderDraw(mudReport);
    tempNumRows = MM.DRILL_STRING_ROWS;
    tempHeight = MM.DRILL_STRING_HEIGHT * 2 / tempNumRows;
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.DRILL_STRING_TOP, MM.DRILL_STRING_WIDTH, tempHeight, 'F');
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.DRILL_STRING_TOP, MM.DRILL_STRING_WIDTH, MM.DRILL_STRING_HEIGHT, 'S');

    // DRILL STRING LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.PAGE_BORDER_WIDTH, MM.DRILL_STRING_TOP, MM.DRILL_STRING_WIDTH, MM.DRILL_STRING_HEIGHT, tempNumRows, mudReport);

    tempLeft = MM.PAGE_BORDER_WIDTH;
    tempTop = MM.DRILL_STRING_TOP + MM.DRILL_STRING_HEIGHT / tempNumRows;
    tempWidth = MM.DRILL_STRING_WIDTH;
    tempHeight = MM.DRILL_STRING_HEIGHT * (tempNumRows - 1) / tempNumRows;
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 4, mudReport);

    // CASING DATA RECTANGLES
    borderDraw(mudReport);
    tempNumRows = MM.CASING_DATA_ROWS;
    tempHeight = MM.CASING_DATA_HEIGHT * 2 / tempNumRows;
    mudReport.rect(MM.CASING_DATA_LEFT, MM.CASING_DATA_TOP, MM.CASING_DATA_WIDTH, tempHeight, 'F');
    mudReport.rect(MM.CASING_DATA_LEFT, MM.CASING_DATA_TOP, MM.CASING_DATA_WIDTH, MM.CASING_DATA_HEIGHT, 'S');

    // CASING DATA LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.CASING_DATA_LEFT, MM.CASING_DATA_TOP, MM.CASING_DATA_WIDTH, MM.CASING_DATA_HEIGHT, tempNumRows, mudReport);
    tempLeft = MM.CASING_DATA_LEFT;
    tempTop = MM.CASING_DATA_TOP + MM.CASING_DATA_HEIGHT / tempNumRows;
    tempWidth = MM.CASING_DATA_WIDTH;
    tempHeight = MM.CASING_DATA_HEIGHT * (tempNumRows - 1) / tempNumRows;
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 4, mudReport);

    // BIT DATA RECTANGLES
    borderDraw(mudReport);
    const tempNumCols = 7;
    tempNumRows = MM.BIT_DATA_ROWS;
    tempWidth = MM.BIT_DATA_WIDTH / tempNumCols;
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.BIT_DATA_TOP, tempWidth, MM.BIT_DATA_HEIGHT, 'F');

    tempLeft = MM.PAGE_BORDER_WIDTH + MM.BIT_DATA_WIDTH * 5 / tempNumCols;
    mudReport.rect(tempLeft, MM.BIT_DATA_TOP, tempWidth, MM.BIT_DATA_HEIGHT, 'F');

    tempWidth = MM.BIT_DATA_WIDTH * (tempNumCols - 1) / tempNumCols;
    tempHeight = MM.BIT_DATA_HEIGHT / tempNumRows;
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.BIT_DATA_TOP, tempWidth, tempHeight, 'F');

    tempLeft = MM.PAGE_BORDER_WIDTH + MM.BIT_DATA_WIDTH * 4 / tempNumCols;
    tempTop = MM.BIT_DATA_TOP + MM.BIT_DATA_HEIGHT / 2;
    tempWidth = MM.BIT_DATA_WIDTH / tempNumCols;
    tempHeight = MM.BIT_DATA_HEIGHT / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.BIT_DATA_TOP, MM.BIT_DATA_WIDTH, MM.BIT_DATA_HEIGHT, 'S');

    // BIT DATA LINES
    tableDraw(mudReport);

    tempLeft = MM.PAGE_BORDER_WIDTH;
    tempTop = MM.BIT_DATA_TOP + MM.BIT_DATA_HEIGHT / 2;
    tempWidth = MM.BIT_DATA_WIDTH / 7;
    tempHeight = MM.BIT_DATA_HEIGHT / 2;

    mudReport.line(tempLeft, tempTop, tempLeft + tempWidth, tempTop);

    tempLeft = MM.PAGE_BORDER_WIDTH + MM.BIT_DATA_WIDTH / 7;
    tempTop = MM.BIT_DATA_TOP;
    tempWidth = MM.BIT_DATA_WIDTH * 6 / 7;
    tempHeight = MM.BIT_DATA_HEIGHT;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);
    equalGrid(tempLeft, tempTop, tempWidth, tempHeight, tempNumRows, 6, mudReport);

    tempTop = MM.BIT_DATA_TOP + MM.BIT_DATA_HEIGHT / 2;
    tempWidth = MM.BIT_DATA_WIDTH * 3 / 7;
    tempHeight = MM.BIT_DATA_HEIGHT / 2;
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 6, mudReport);

    // CIRC VOL RECTANGLES
    borderDraw(mudReport);

    tempNumRows = MM.CIRC_VOL_ROWS;
    tempLeft = MM.CIRC_VOL_LEFT;
    tempTop = MM.CIRC_VOL_TOP;
    tempWidth = MM.CIRC_VOL_WIDTH;
    tempHeight = MM.CIRC_VOL_HEIGHT / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempTop = MM.CIRC_VOL_TOP + MM.CIRC_VOL_HEIGHT * 5 / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempTop = MM.CIRC_VOL_TOP;
    tempWidth = MM.CIRC_VOL_WIDTH * 3 / 5;
    tempHeight = MM.CIRC_VOL_HEIGHT;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.CIRC_VOL_LEFT, MM.CIRC_VOL_TOP, MM.CIRC_VOL_WIDTH, MM.CIRC_VOL_HEIGHT, 'S');

    // CIRC VOL LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.CIRC_VOL_LEFT, MM.CIRC_VOL_TOP, MM.CIRC_VOL_WIDTH, MM.CIRC_VOL_HEIGHT, tempNumRows, mudReport);
    tempLeft = MM.CIRC_VOL_LEFT + MM.CIRC_VOL_WIDTH * 3 / 5;
    tempTop = MM.CIRC_VOL_TOP + MM.CIRC_VOL_HEIGHT / tempNumRows;
    tempHeight = MM.CIRC_VOL_HEIGHT / 2;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);
    tempTop = MM.CIRC_VOL_TOP + MM.CIRC_VOL_HEIGHT * 3 / 4;
    tempHeight = MM.CIRC_VOL_HEIGHT / 4;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);

    // PUMP DATA RECTANGLES
    borderDraw(mudReport);
    tempNumRows = MM.PUMP_DATA_ROWS;
    tempLeft = MM.PUMP_DATA_LEFT;
    tempTop = MM.PUMP_DATA_TOP;
    tempWidth = MM.PUMP_DATA_WIDTH;
    tempHeight = MM.PUMP_DATA_HEIGHT / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempWidth = MM.PUMP_DATA_WIDTH / 3;
    tempHeight = MM.PUMP_DATA_HEIGHT;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.PUMP_DATA_LEFT, MM.PUMP_DATA_TOP, MM.PUMP_DATA_WIDTH, MM.PUMP_DATA_HEIGHT, 'S');

    // PUMP DATA LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.PUMP_DATA_LEFT, MM.PUMP_DATA_TOP, MM.PUMP_DATA_WIDTH, MM.PUMP_DATA_HEIGHT, MM.PUMP_DATA_ROWS, mudReport);

    tempLeft = MM.PUMP_DATA_LEFT + MM.PUMP_DATA_WIDTH / 3;
    tempTop = MM.PUMP_DATA_TOP;
    tempHeight = MM.PUMP_DATA_HEIGHT;
    tempWidth = MM.PUMP_DATA_WIDTH * 2 / 3;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 4, mudReport);

    // CIRC DATA RECTANGLES
    borderDraw(mudReport);
    tempNumRows = 3;
    tempLeft = MM.CIRC_DATA_LEFT;
    tempTop = MM.CIRC_DATA_TOP;
    tempWidth = MM.CIRC_DATA_WIDTH;
    tempHeight = MM.CIRC_DATA_HEIGHT / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempWidth = MM.CIRC_DATA_WIDTH / 8;
    tempHeight = MM.CIRC_DATA_HEIGHT;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempLeft = MM.CIRC_DATA_LEFT + MM.CIRC_DATA_WIDTH / 4;
    tempWidth = MM.CIRC_DATA_WIDTH * 3 / 4 / 5;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.CIRC_DATA_LEFT, MM.CIRC_DATA_TOP, MM.CIRC_DATA_WIDTH, MM.CIRC_DATA_HEIGHT, 'S');


    // CIRC DATA LINE
    tableDraw(mudReport);
    equalLinesHorizonal(MM.CIRC_DATA_LEFT, MM.CIRC_DATA_TOP, MM.CIRC_DATA_WIDTH, MM.CIRC_DATA_HEIGHT, 3, mudReport);
    tempLeft = MM.CIRC_DATA_LEFT;
    tempTop = MM.CIRC_DATA_TOP + MM.CIRC_DATA_HEIGHT / 3;
    tempWidth = MM.CIRC_DATA_WIDTH / 4;
    tempHeight = MM.CIRC_DATA_HEIGHT * 2 / 3;
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 2, mudReport);

    tempLeft = MM.CIRC_DATA_LEFT + MM.CIRC_DATA_WIDTH / 4;
    tempTop = MM.CIRC_DATA_TOP;
    tempWidth = MM.CIRC_DATA_WIDTH * 3 / 4;
    tempHeight = MM.CIRC_DATA_HEIGHT;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 5, mudReport);

    // MUD PROPERTIES RECTANGLES
    borderDraw(mudReport);
    let tempWidthArr = [];
    if (test.mudProperty === 'Oil Based Mud') {
        tempNumRows = MM.MUD_PROP_SPEC_ROWS_OBM;
        tempWidthArr = widthArrayOBM;
    } else {
        tempNumRows = MM.MUD_PROP_SPEC_ROWS_WBM;
        tempWidthArr = widthArrayWBM;
    }
    mudPropertyHeaderShading(MM.PAGE_BORDER_WIDTH, MM.MUD_PROP_SPEC_TOP, MM.MUD_PROP_SPEC_WIDTH, MM.MUD_PROP_SPEC_HEIGHT, tempNumRows, tempWidthArr, mudReport);
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.MUD_PROP_SPEC_TOP, MM.MUD_PROP_SPEC_WIDTH, MM.MUD_PROP_SPEC_HEIGHT, 'S');

    // MUD PROPERTIES LINES
    tableDraw(mudReport);
    mudPropertyLines(MM.PAGE_BORDER_WIDTH, MM.MUD_PROP_SPEC_TOP, MM.MUD_PROP_SPEC_WIDTH, MM.MUD_PROP_SPEC_HEIGHT, tempNumRows, test.mudProperty, mudReport);
    equalLinesHorizonal(MM.PAGE_BORDER_WIDTH, MM.MUD_PROP_SPEC_TOP, MM.MUD_PROP_SPEC_WIDTH, MM.MUD_PROP_SPEC_HEIGHT, tempNumRows, mudReport);



    // TOURLY TREATMENT RECTANGLES
    borderDraw(mudReport);
    tempLeft = MM.TOURLY_LEFT;
    tempTop = MM.TOURLY_TOP;
    tempWidth = MM.TOURLY_WIDTH;
    tempHeight = MM.SECTION_HEADER_HEIGHT;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.TOURLY_LEFT, MM.TOURLY_TOP, MM.TOURLY_WIDTH, MM.TOURLY_HEIGHT, 'S');

    // TOURLY TREATMENT LINES
    tableDraw(mudReport);
    tempTop = MM.TOURLY_TOP + MM.SECTION_HEADER_HEIGHT;
    mudReport.line(tempLeft, tempTop, tempLeft + MM.TOURLY_WIDTH, tempTop);

    // SURVEY RECTANGLES
    borderDraw(mudReport);
    tempNumRows = MM.SURVEY_ROWS;
    tempLeft = MM.SURVEY_LEFT;
    tempTop = MM.SURVEY_TOP;
    tempWidth = MM.SURVEY_WIDTH;
    tempHeight = MM.SURVEY_HEIGHT * 2 / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');
    mudReport.rect(MM.SURVEY_LEFT, MM.SURVEY_TOP, MM.SURVEY_WIDTH, MM.SURVEY_HEIGHT, 'S');


    // SURVEY LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.SURVEY_LEFT, MM.SURVEY_TOP, MM.SURVEY_WIDTH, MM.SURVEY_HEIGHT, 5, mudReport);

    tempLeft = MM.SURVEY_LEFT;
    tempTop = MM.SURVEY_TOP + MM.SURVEY_HEIGHT / 5;
    tempWidth = MM.SURVEY_WIDTH;
    tempHeight = MM.SURVEY_HEIGHT * 4 / 5;
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 3, mudReport);


    // EXTERNAL STORAGE RECTANGLES
    borderDraw(mudReport);
    tempNumRows = 7;
    tempLeft = MM.EXTERNAL_LEFT;
    tempTop = MM.EXTERNAL_TOP;
    tempWidth = MM.EXTERNAL_WIDTH;
    tempHeight = MM.EXTERNAL_HEIGHT * 2 / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempWidth = MM.EXTERNAL_WIDTH / 2;
    tempHeight = MM.EXTERNAL_HEIGHT;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.EXTERNAL_LEFT, MM.EXTERNAL_TOP, MM.EXTERNAL_WIDTH, MM.EXTERNAL_HEIGHT, 'S');

    // EXTERNAL STORAGE LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.EXTERNAL_LEFT, MM.EXTERNAL_TOP, MM.EXTERNAL_WIDTH, MM.EXTERNAL_HEIGHT, 7, mudReport);
    tempLeft = MM.EXTERNAL_LEFT + MM.EXTERNAL_WIDTH / 2;
    tempTop = MM.EXTERNAL_TOP + MM.EXTERNAL_HEIGHT / 7;
    tempWidth = MM.EXTERNAL_WIDTH / 2;
    tempHeight = MM.EXTERNAL_HEIGHT * 6 / 7;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 2, mudReport);


    // VOLUME ACCOUNTING RECTANGLES
    borderDraw(mudReport);
    tempNumRows = 11;
    tempLeft = MM.VOLUME_LEFT;
    tempTop = MM.VOLUME_TOP;
    tempWidth = MM.VOLUME_WIDTH;
    tempHeight = MM.VOLUME_HEIGHT * 3 / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempWidth = MM.VOLUME_WIDTH * 3 / 4;
    tempHeight = MM.VOLUME_HEIGHT;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.VOLUME_LEFT, MM.VOLUME_TOP, MM.VOLUME_WIDTH, MM.VOLUME_HEIGHT, 'S');

    // VOLUME ACCOUNTING LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.VOLUME_LEFT, MM.VOLUME_TOP, MM.VOLUME_WIDTH, MM.VOLUME_HEIGHT, 11, mudReport);

    tempLeft = MM.VOLUME_LEFT + MM.VOLUME_WIDTH * 3 / 4;
    tempTop = MM.VOLUME_TOP + MM.VOLUME_HEIGHT * 2 / 11;
    tempWidth = MM.VOLUME_WIDTH / 4;
    tempHeight = MM.VOLUME_HEIGHT * 9 / 11;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);

    // PRODUCTS RECTANGLES
    borderDraw(mudReport);
    tempNumRows = 17;
    tempLeft = MM.PRODUCT_LEFT;
    tempTop = MM.PRODUCT_TOP;
    tempWidth = MM.PRODUCT_WIDTH;
    tempHeight = MM.PRODUCT_HEIGHT * 2 / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.PRODUCT_LEFT, MM.PRODUCT_TOP, MM.PRODUCT_WIDTH, MM.PRODUCT_HEIGHT, 'S');

    // PRODUCTS LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.PRODUCT_LEFT, MM.PRODUCT_TOP, MM.PRODUCT_WIDTH, MM.PRODUCT_HEIGHT, 17, mudReport);

    tempLeft = MM.PRODUCT_LEFT + MM.PRODUCT_WIDTH / 4;
    tempTop = MM.PRODUCT_TOP + MM.PRODUCT_HEIGHT / 17;
    tempWidth = MM.PRODUCT_WIDTH / 4;
    tempHeight = MM.PRODUCT_HEIGHT * 16 / 17;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 2, mudReport);
    tempLeft += MM.PRODUCT_WIDTH / 4;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);

    tempLeft += MM.PRODUCT_WIDTH / 4;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 2, mudReport);


    // EBP RECTANGLES
    borderDraw(mudReport);
    tempNumRows = 5;
    tempLeft = MM.EBP_LEFT;
    tempTop = MM.EBP_TOP;
    tempWidth = MM.EBP_WIDTH;
    tempHeight = MM.EBP_HEIGHT * 2 / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.EBP_LEFT, MM.EBP_TOP, MM.EBP_WIDTH, MM.EBP_HEIGHT, 'S');

    // EBP LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.EBP_LEFT, MM.EBP_TOP, MM.EBP_WIDTH, MM.EBP_HEIGHT, 5, mudReport);

    tempLeft = MM.EBP_LEFT + MM.EBP_WIDTH / 4;
    tempTop = MM.EBP_TOP + MM.EBP_HEIGHT / 5;
    tempWidth = MM.EBP_WIDTH / 4;
    tempHeight = MM.EBP_HEIGHT * 4 / 5;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 2, mudReport);
    tempLeft += MM.EBP_WIDTH / 4;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);

    tempLeft += MM.EBP_WIDTH / 4;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);
    equalLinesVertical(tempLeft, tempTop, tempWidth, tempHeight, 2, mudReport);


    // COSTS RECTANGLES
    borderDraw(mudReport);
    tempLeft = MM.COST_LEFT;
    tempTop = MM.COST_TOP;
    tempWidth = MM.COST_WIDTH / 4;
    tempHeight = MM.COST_HEIGHT;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempLeft = MM.COST_LEFT + MM.COST_WIDTH / 2;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.COST_LEFT, MM.COST_TOP, MM.COST_WIDTH, MM.COST_HEIGHT, 'S');

    // COST LINES
    tableDraw(mudReport);
    equalLinesVertical(MM.COST_LEFT, MM.COST_TOP, MM.COST_WIDTH, MM.COST_HEIGHT, 4, mudReport);


    // HYDRAULICS RECTANGLES
    borderDraw(mudReport);
    tempNumRows = MM.HYDRA_ROWS;
    tempLeft = MM.HYDRA_LEFT;
    tempTop = MM.HYDRA_TOP;
    tempWidth = MM.HYDRA_WIDTH;
    tempHeight = MM.HYDRA_HEIGHT / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    tempWidth = MM.HYDRA_WIDTH * 3 / 4;
    tempHeight = MM.HYDRA_HEIGHT;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.HYDRA_LEFT, MM.HYDRA_TOP, MM.HYDRA_WIDTH, MM.HYDRA_HEIGHT, 'S');

    // HYDRAULICS LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.HYDRA_LEFT, MM.HYDRA_TOP, MM.HYDRA_WIDTH, MM.HYDRA_HEIGHT, MM.HYDRA_ROWS, mudReport);

    tempLeft = MM.HYDRA_LEFT + MM.HYDRA_WIDTH * 3 / 4;
    tempTop = MM.HYDRA_TOP + MM.HYDRA_HEIGHT / 12;
    tempWidth = MM.HYDRA_WIDTH / 4;
    tempHeight = MM.HYDRA_HEIGHT * 11 / 12;
    mudReport.line(tempLeft, tempTop, tempLeft, tempTop + tempHeight);

    // SOLIDS RECTANGLES
    borderDraw(mudReport);
    tempNumRows = 8;
    tempLeft = MM.PAGE_BORDER_WIDTH;
    tempTop = MM.SOLIDS_TOP;
    tempWidth = MM.SOLIDS_WIDTH;
    tempHeight = MM.SOLIDS_HEIGHT * 2 / tempNumRows;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.SOLIDS_TOP, MM.SOLIDS_WIDTH, MM.SOLIDS_HEIGHT, 'S');

    // SOLIDS LINES
    tableDraw(mudReport);
    equalLinesHorizonal(MM.PAGE_BORDER_WIDTH, MM.SOLIDS_TOP, MM.SOLIDS_WIDTH, MM.SOLIDS_HEIGHT, 8, mudReport);

    tempHeight = MM.SOLIDS_HEIGHT / MM.SOLIDS_ROWS;
    tempTop = MM.SOLIDS_TOP + tempHeight;
    tempHeight = MM.SOLIDS_HEIGHT - tempHeight;

    const gapDiv = MM.SOLIDS_WIDTH / 6;
    tempLeft = MM.PAGE_BORDER_WIDTH + gapDiv * 3;
    const tempBottom = tempTop + tempHeight;
    mudReport.line(tempLeft, tempTop, tempLeft, tempBottom);

    tempLeft = tempLeft + gapDiv * 1;
    mudReport.line(tempLeft, tempTop, tempLeft, tempBottom);

    tempLeft = tempLeft + gapDiv * 1;
    mudReport.line(tempLeft, tempTop, tempLeft, tempBottom);


    // RECAP RECTANGLES
    borderDraw(mudReport);
    tempLeft = MM.RECAP_LEFT;
    tempTop = MM.RECAP_TOP;
    tempWidth = MM.RECAP_WIDTH;
    tempHeight = MM.SECTION_HEADER_HEIGHT;
    mudReport.rect(tempLeft, tempTop, tempWidth, tempHeight, 'F');

    mudReport.rect(MM.RECAP_LEFT, MM.RECAP_TOP, MM.RECAP_WIDTH, MM.RECAP_HEIGHT, 'S');

    // RECAP LINES
    tableDraw(mudReport);
    tempTop = MM.RECAP_TOP + MM.SECTION_HEADER_HEIGHT;
    mudReport.line(tempLeft, tempTop, tempLeft + MM.RECAP_WIDTH, tempTop);

    // ENGINEER RECTANGLES
    borderDraw(mudReport);
    tempHeight = MM.ENGINEER_HEIGHT / 2;
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.ENGINEER_TOP, MM.ENGINEER_WIDTH, tempHeight, 'F');
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.ENGINEER_TOP, MM.ENGINEER_WIDTH, MM.ENGINEER_HEIGHT, 'S');

    // ENGINEER LINES
    tableDraw(mudReport);
    equalGrid(MM.PAGE_BORDER_WIDTH, MM.ENGINEER_TOP, MM.ENGINEER_WIDTH, MM.ENGINEER_HEIGHT, 2, 6, mudReport);

    // FOOTER
    borderDraw(mudReport);
    mudReport.rect(MM.PAGE_BORDER_WIDTH, MM.FOOTER_TOP, MM.FOOTER_WIDTH, MM.FOOTER_HEIGHT, 'S');

    if (draft) {
        mudReport.setTextColor(225);
        mudReport.setFontSize(160);
        mudReport.text(5, 150, 'Preview');
        mudReport.setTextColor(0);
    }

    DATA.populateHeader(test, well, logoBlob, mudReport);
    DATA.populateWellInfo(test, well, mudReport);
    DATA.populateDrillString(test, mudReport);
    DATA.populateCasingData(test, mudReport);
    DATA.populateCirVolData(test, mudReport);
    DATA.populatePumpData(test, mudReport);
    DATA.populateBitData(test, mudReport);
    DATA.populateCircData(test, mudReport);
    DATA.populateMudProperties(test, mudReport);
    DATA.populateTourly(test, mudReport);
    DATA.populateSurveys(test, mudReport);
    DATA.populateExternalStorage(test, mudReport);
    DATA.populateVolumeAccounting(test, mudReport);
    DATA.populateHydra(test, mudReport);
    DATA.populateProducts(test, mudReport);
    DATA.populateEBP(test, mudReport);
    DATA.populateInventoryTotals(test, mudReport);
    DATA.populateSolids(test, mudReport);
    DATA.populateRecap(test, mudReport);
    DATA.populateEngineer(well, test, mudReport);
    DATA.populateFooter(mudReport);


    return mudReport;

};


/*************************************************************************************************************
* 
*
*  DRAWING FUNCTIONS
* 
* 
**************************************************************************************************************/


export const equalLinesHorizonal = (left: number, top: number, width: number, height: number, numGaps: number, mudReport: jsPdf) => {
    const lineGap = height / numGaps;
    const x2 = left + width;
    let currTop = top + lineGap;

    for (let i = 1; i < numGaps; ++i) {
        mudReport.line(left, currTop, x2, currTop);
        currTop += lineGap;
    }
};

export const equalLinesVertical = (left: number, top: number, width: number, height: number, numGaps: number, mudReport: jsPdf) => {
    const lineGap = width / numGaps;
    const y2 = top + height;
    let currLeft = left + lineGap;

    for (let i = 1; i < numGaps; ++i) {
        mudReport.line(currLeft, top, currLeft, y2);
        currLeft += lineGap;
    }
};

export const equalGrid = (left: number, top: number, width: number, height: number, numGapsX: number, numGapsY: number, mudReport: jsPdf) => {
    equalLinesHorizonal(left, top, width, height, numGapsX, mudReport);
    equalLinesVertical(left, top, width, height, numGapsY, mudReport);
};

export const mudPropertyHeaderShading = (left: number, top: number, width: number, height: number, numRows: number, widthArray: number[], mudReport: jsPdf) => {
    const rowGap = height / numRows;

    let tempWidth = width;
    let tempTop = top;
    for (const widthFactor of widthArray) {
        tempWidth = width * widthFactor;
        mudReport.rect(left, tempTop, tempWidth, rowGap, 'F');
        tempTop += rowGap;
    }
};

const mudPropertyLinesBoth = (left: number, top: number, width: number, height: number, numRows: number, mudReport: jsPdf) => {
    const rowGap = height / numRows;
    let tempTop = top + rowGap;
    const middle = left + width / 2;
    const threeQuarter = left + width * 3 / 4;
    equalLinesVertical(left, tempTop, width, rowGap * 2, 5, mudReport);

    tempTop += rowGap * 3;
    mudReport.line(threeQuarter, tempTop, threeQuarter, tempTop + rowGap * 6);

    tempTop += rowGap * 5;
    mudReport.line(middle, tempTop, middle, tempTop + rowGap);

    tempTop += rowGap * 2;
    equalLinesVertical(left, tempTop, width, rowGap * 2, 6, mudReport);

    tempTop += rowGap * 2;
    mudReport.line(middle, tempTop, middle, tempTop + rowGap);
    mudReport.line(threeQuarter, tempTop, threeQuarter, tempTop + rowGap * 2);

    tempTop += rowGap * 3;
    equalLinesVertical(left, tempTop, width, rowGap * 2, 3, mudReport);

    tempTop += rowGap * 2;
    mudReport.line(middle, tempTop, middle, tempTop + rowGap * 2);
    mudReport.line(threeQuarter, tempTop, threeQuarter, tempTop + rowGap * 7);
};

const mudPropertyLinesWBM = (left: number, top: number, width: number, height: number, numRows: number, mudReport: jsPdf) => {
    const rowGap = height / numRows;
    let tempTop = top + rowGap * 25;

    const threeQuarter = left + width * 3 / 4;

    mudReport.line(threeQuarter, tempTop, threeQuarter, tempTop + rowGap * 3);

    tempTop += rowGap * 4;
    equalLinesVertical(left, tempTop, width, rowGap * 2, 3, mudReport);

    tempTop += rowGap * 2;
    mudReport.line(threeQuarter, tempTop, threeQuarter, tempTop + rowGap * 2);

    tempTop += rowGap * 3;
    equalLinesVertical(left, tempTop, width, rowGap * 2, 3, mudReport);

    tempTop += rowGap * 2;
    mudReport.line(threeQuarter, tempTop, threeQuarter, tempTop + rowGap * 2);

    tempTop += rowGap * 3;
    equalLinesVertical(left, tempTop, width, rowGap * 3, 4, mudReport);

    tempTop += rowGap * 3;
    mudReport.line(threeQuarter, tempTop, threeQuarter, tempTop + rowGap * 3);

};

const mudPropertyLinesOBM = (left: number, top: number, width: number, height: number, numRows: number, mudReport: jsPdf) => {
    const rowGap = height / numRows;
    let tempTop = top + rowGap * 25;

    const threeQuarter = left + width * 3 / 4;
    mudReport.line(threeQuarter, tempTop, threeQuarter, tempTop + rowGap * 9);

    tempTop += rowGap * 10;
    equalLinesVertical(left, tempTop, width, rowGap * 3, 4, mudReport);

    tempTop += rowGap * 3;
    mudReport.line(threeQuarter, tempTop, threeQuarter, tempTop + rowGap * 4);

};
const mudPropertyLines = (left: number, top: number, width: number, height: number, numRows: number, mudType: string, mudReport: jsPdf) => {
    mudPropertyLinesBoth(left, top, width, height, numRows, mudReport);

    if (mudType === 'Oil Based Mud') {
        mudPropertyLinesOBM(left, top, width, height, numRows, mudReport);
    } else {
        mudPropertyLinesWBM(left, top, width, height, numRows, mudReport);
    }
};

const borderDraw = (mudReport: jsPdf) => {
    mudReport.setDrawColor(MM.OUTER_BORDER_COLOR);
    mudReport.setLineWidth(MM.OUTER_BORDER_WIDTH);
};

const tableDraw = (mudReport: jsPdf) => {
    mudReport.setDrawColor(MM.INNER_BORDER_COLOR);
    mudReport.setLineWidth(MM.INNER_BORDER_WIDTH);
};

const widthArrayOBM = [
    1,
    1,
    0,
    1,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    1 / 2,
    1,
    1,
    0,
    1 / 2,
    3 / 4,
    1,
    1,
    0,
    1 / 2,
    1 / 2,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    1,
    1,
    1 / 4,
    1 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4
];

const widthArrayWBM = [
    1,
    1,
    0,
    1,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    1 / 2,
    1,
    1,
    0,
    1 / 2,
    3 / 4,
    1,
    1,
    0,
    1 / 2,
    1 / 2,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
    1,
    1,
    0,
    3 / 4,
    3 / 4,
    1,
    1,
    0,
    3 / 4,
    3 / 4,
    1,
    1,
    1 / 4,
    1 / 4,
    3 / 4,
    3 / 4,
    3 / 4,
];


// WEBPACK FOOTER //
// ./src/Services/Pdf/MudReport/DrawReportMud.ts